/** Views sit inside their author's publication; the server redirects the old path. */
function viewHref(view) {
  const username = view?.author?.username || view?.authorUsername || '';
  return username
    ? `/_/${encodeURIComponent(username)}/views/${encodeURIComponent(view.slug)}`
    : `/views/${encodeURIComponent(view.slug)}`;
}


const ACCENTS = {
  cobalt: '#7190ff',
  violet: '#ad7aff',
  ember: '#f08055',
  moss: '#77a880',
  rose: '#e47d99',
  slate: '#8da0b4',
};

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function formatDate(timestamp) {
  if (!timestamp) return '';
  const seconds = timestamp._seconds ?? timestamp.seconds;
  if (!seconds) return '';
  return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric', year: 'numeric' })
    .format(new Date(seconds * 1000));
}

function renderViews(views) {
  const grid = document.getElementById('views-grid');
  if (!grid) return;
  if (!views.length) {
    grid.innerHTML = `
      <div class="views-empty-state">
        <div class="empty-view-visual" aria-hidden="true">
          <svg viewBox="0 0 520 300">
            <line x1="260" y1="150" x2="94" y2="72"></line>
            <line x1="260" y1="150" x2="425" y2="68"></line>
            <line x1="260" y1="150" x2="105" y2="236"></line>
            <line x1="260" y1="150" x2="418" y2="232"></line>
            <circle cx="260" cy="150" r="48" class="empty-core"></circle>
            <circle cx="94" cy="72" r="14"></circle>
            <circle cx="425" cy="68" r="14"></circle>
            <circle cx="105" cy="236" r="14"></circle>
            <circle cx="418" cy="232" r="14"></circle>
          </svg>
          <span class="empty-idea empty-idea-one">A claim</span>
          <span class="empty-idea empty-idea-two">A tension</span>
          <span class="empty-idea empty-idea-three">An implication</span>
          <span class="empty-idea empty-idea-four">Your lens</span>
          <strong>The first View</strong>
        </div>
        <div class="empty-view-copy">
          <p class="section-kicker">The beginning</p>
          <h3>The first View is taking shape.</h3>
          <p>
            Soon, this space will hold complete writing you can read linearly,
            see as a connected structure, and explore through your own lens.
          </p>
          <div class="empty-view-actions">
            <a class="button button-accent" href="/login?return=/studio">Open author studio</a>
            <a class="empty-view-link" href="#experience">See how a View works <span aria-hidden="true">↑</span></a>
          </div>
        </div>
      </div>`;
    return;
  }
  const ordered = [...views]
    .sort((a, b) => Number(b.featured) - Number(a.featured))
    .slice(0, 3);
  grid.innerHTML = ordered.map((view) => `
    <a class="view-card" href="${viewHref(view)}"
       style="--card-accent:${ACCENTS[view.accent] || ACCENTS.cobalt}">
      <div class="view-card-meta">
        <span>${escapeHtml((view.topics || [])[0] || 'View')}</span>
        <span>${view.readingMinutes || 1} min · ${escapeHtml(formatDate(view.publishedAt))}</span>
      </div>
      <h3 class="view-card-title">${escapeHtml(view.title)}</h3>
      <p class="view-card-deck">${escapeHtml(view.deck)}</p>
      <p class="view-card-author">By ${escapeHtml(view.author?.displayName || view.author?.username || 'A ThinqWith writer')}</p>
      <div class="view-card-nodes">
        ${(view.fractalPreview?.labels || []).slice(0, 3).map((label) =>
          `<span class="view-card-node">${escapeHtml(label)}</span>`
        ).join('')}
      </div>
    </a>
  `).join('');
}

document.getElementById('year').textContent = new Date().getFullYear();

const introCues = [
  {
    trigger: document.querySelector('.pm-intro-idea'),
    card: document.getElementById('pm-intro-idea-card'),
  },
  {
    trigger: document.querySelector('.pm-intro-nuance'),
    card: document.getElementById('pm-intro-nuance-card'),
  },
].filter(({ trigger, card }) => trigger && card);

let openIntroCue = null;

function positionIntroCard(trigger, card) {
  if (window.innerWidth <= 720 || card.hidden) return;
  const triggerRect = trigger.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  const gutter = 14;
  const preferredLeft = triggerRect.left + (triggerRect.width / 2) - (cardRect.width / 2);
  const left = Math.min(
    Math.max(gutter, preferredLeft),
    window.innerWidth - cardRect.width - gutter
  );
  const roomBelow = window.innerHeight - triggerRect.bottom;
  const top = roomBelow >= cardRect.height + 12
    ? triggerRect.bottom + 10
    : triggerRect.top - cardRect.height - 10;
  card.style.left = `${left}px`;
  card.style.top = `${Math.max(gutter, top)}px`;
}

function closeIntroCard({ restoreFocus = false } = {}) {
  if (!openIntroCue) return;
  const { trigger, card } = openIntroCue;
  card.hidden = true;
  trigger.setAttribute('aria-expanded', 'false');
  if (restoreFocus) trigger.focus();
  openIntroCue = null;
}

function openIntroCard(cue) {
  if (openIntroCue === cue) {
    closeIntroCard();
    return;
  }
  closeIntroCard();
  cue.card.hidden = false;
  cue.trigger.setAttribute('aria-expanded', 'true');
  openIntroCue = cue;
  positionIntroCard(cue.trigger, cue.card);
}

introCues.forEach((cue) => {
  cue.trigger.addEventListener('click', (clickEvent) => {
    clickEvent.stopPropagation();
    openIntroCard(cue);
  });
  cue.card.addEventListener('click', (clickEvent) => clickEvent.stopPropagation());
  cue.card.querySelector('.pm-intro-card-close')?.addEventListener('click', () => {
    closeIntroCard({ restoreFocus: true });
  });
});

document.addEventListener('click', () => closeIntroCard());
document.addEventListener('keydown', (keyEvent) => {
  if (keyEvent.key === 'Escape') closeIntroCard({ restoreFocus: true });
});
window.addEventListener('resize', () => {
  if (openIntroCue) positionIntroCard(openIntroCue.trigger, openIntroCue.card);
});
window.addEventListener('scroll', () => {
  if (openIntroCue) positionIntroCard(openIntroCue.trigger, openIntroCue.card);
}, { passive: true });

function setupIndexScrollChoreography() {
  const page = document.body;
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (!page?.classList.contains('marketing-page') || reduceMotion || !('IntersectionObserver' in window)) return;

  const revealGroups = [
    ['.who-head'],
    ['.who-profiles > article'],
    ['.who-bridge'],
    ['.view-definition-head'],
    ['.view-form-line:not(.models-line)'],
    ['.view-definition-principles > article'],
    ['.view-definition-test'],
    ['.reader-play-head'],
    ['.reader-play-steps > article'],
    ['.reader-play-nuance'],
    ['.models-head'],
    ['.models-sides > article'],
    ['.models-line'],
    ['.audience-head'],
    ['.audience-options > article'],
    ['.audience-return > div'],
    ['.audience-note'],
    ['.studio-compact-copy'],
    ['.studio-compact-steps > article'],
    ['.reader-pricing-note'],
    ['.views-section .section-head'],
    ['.closing-cta'],
  ];
  const revealTargets = new Set();

  revealGroups.forEach(([selector]) => {
    document.querySelectorAll(selector).forEach((element, order) => {
      element.classList.add('scroll-reveal');
      element.style.setProperty('--reveal-delay', `${Math.min(order, 3) * 75}ms`);
      revealTargets.add(element);
    });
  });

  if (!revealTargets.size) return;
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

  page.classList.add('scroll-choreo');
  revealTargets.forEach((element) => revealObserver.observe(element));

  const nav = document.querySelector('.publication-nav');
  const readerCard = document.querySelector('.pm-reader');
  const whoSection = document.querySelector('.who-section');
  let motionFrame = 0;

  function updateScrollMotion() {
    motionFrame = 0;
    const viewportHeight = Math.max(window.innerHeight, 1);
    const maxScroll = Math.max(document.documentElement.scrollHeight - viewportHeight, 1);
    const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
    nav?.style.setProperty('--page-progress', progress.toFixed(4));

    if (window.innerWidth <= 720) {
      readerCard?.style.removeProperty('--reader-shift');
      whoSection?.style.removeProperty('--who-shift');
      return;
    }

    if (readerCard) {
      const readerRect = readerCard.getBoundingClientRect();
      const readerPosition = (readerRect.top + (readerRect.height / 2) - (viewportHeight / 2)) / viewportHeight;
      const readerShift = Math.min(14, Math.max(-14, readerPosition * -16));
      readerCard.style.setProperty('--reader-shift', `${readerShift.toFixed(2)}px`);
    }

    if (whoSection) {
      const whoRect = whoSection.getBoundingClientRect();
      const whoPosition = (whoRect.top + (whoRect.height / 2) - (viewportHeight / 2)) / viewportHeight;
      const whoShift = Math.min(28, Math.max(-28, whoPosition * -24));
      whoSection.style.setProperty('--who-shift', `${whoShift.toFixed(2)}px`);
    }
  }

  function requestScrollMotion() {
    if (motionFrame) return;
    motionFrame = window.requestAnimationFrame(updateScrollMotion);
  }

  window.addEventListener('scroll', requestScrollMotion, { passive: true });
  window.addEventListener('resize', requestScrollMotion);
  if ('ResizeObserver' in window) new ResizeObserver(requestScrollMotion).observe(document.body);
  updateScrollMotion();
}

setupIndexScrollChoreography();

/**
 * Draws the section motifs with the same renderer the reading experience uses, so
 * the homepage and a View are made by one hand. Imported lazily: the drawn layer
 * is atmosphere, and it must never delay the writing it sits behind.
 *
 * A motif assembles when it is reached rather than on load — the movement is the
 * meaning, and one that has already finished by the time it is seen says nothing.
 */
async function drawSectionMotifs() {
  const holders = document.querySelectorAll('.section-motif[data-motif]');
  if (!holders.length) return;
  // Below the breakpoint the motifs are display:none; drawing them would cost the
  // import and the DOM for something no one sees.
  if (window.innerWidth <= 900) return;

  let renderers;
  try {
    ({ MOTIF_RENDERERS: renderers } = await import('./atmosphere/motifs.js'));
  } catch {
    return; // The page is complete without the drawn layer.
  }

  const stillness = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const observer = 'IntersectionObserver' in window && !stillness
    ? new IntersectionObserver((entries, self) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('motif-live');
        self.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 })
    : null;

  holders.forEach((holder) => {
    const render = renderers[holder.dataset.motif];
    if (!render) return;
    const intensity = Number(holder.dataset.intensity) || 2;
    const figure = document.createElement('div');
    figure.className = 'motif';
    figure.dataset.intensity = String(intensity);
    figure.appendChild(render(intensity));
    holder.appendChild(figure);
    // Without an observer the form is simply already assembled, never absent.
    if (observer) observer.observe(figure);
    else figure.classList.add('motif-live');
  });
}

if ('requestIdleCallback' in window) {
  window.requestIdleCallback(drawSectionMotifs, { timeout: 1800 });
} else {
  window.setTimeout(drawSectionMotifs, 400);
}

async function enhanceSignedInNavigation() {
  try {
    const [{ onAuthStateChanged }, { auth }] = await Promise.all([
      import('firebase/auth'),
      import('./auth.js'),
    ]);
    onAuthStateChanged(auth, (user) => {
      const link = document.getElementById('studio-link');
      if (user?.emailVerified && link) {
        link.href = '/studio';
        link.textContent = 'Open studio';
        // Someone signed in has read and written things; from here they had no route
        // to either. The link is only added for them, so the page a stranger sees is
        // unchanged.
        if (!document.getElementById('account-link')) {
          const account = document.createElement('a');
          account.id = 'account-link';
          account.className = 'nav-link';
          account.href = '/me';
          account.textContent = 'Your account';
          link.parentNode.insertBefore(account, link);
        }
      }
    });
  } catch {
    // The public homepage and Studio link still work if optional auth hydration fails.
  }
}

if ('requestIdleCallback' in window) {
  window.requestIdleCallback(enhanceSignedInNavigation, { timeout: 2200 });
} else {
  window.setTimeout(enhanceSignedInNavigation, 700);
}

fetch('/api/v1/views/public', { headers: { Accept: 'application/json' } })
  .then((response) => {
    if (!response.ok) throw new Error('Could not load public Views');
    return response.json();
  })
  .then(({ data }) => renderViews(data?.views || []))
  .catch(() => renderViews([]));
